function isUnsupportedFirefoxForWebPush() {
  if (typeof navigator === "undefined") {
    return false;
  }

  var match = navigator.userAgent.match(/Firefox\/(\d+)/);
  if (!match) {
    return false;
  }

  return Number(match[1]) <= 52;
}

export function isPushFeatureAvailable() {
  return !isUnsupportedFirefoxForWebPush();
}

async function waitForActiveServiceWorker(registration) {
  if (registration.active) {
    return registration;
  }

  var worker = registration.installing || registration.waiting;
  if (!worker) {
    await navigator.serviceWorker.ready;
    return registration;
  }

  await new Promise(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      reject(new Error("Service Worker activation timeout"));
    }, 10000);

    worker.addEventListener("statechange", function () {
      if (worker.state === "activated") {
        clearTimeout(timeoutId);
        resolve();
      }
    });
  });

  return registration;
}

export async function getFirebaseMessagingServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator) || !isPushFeatureAvailable()) {
    return null;
  }

  var swVersion = process.env.VUE_APP_SW_VERSION || "1";
  var swUrl =
    process.env.BASE_URL +
    "firebase-messaging-sw.js?v=" +
    encodeURIComponent(swVersion);
  var registration = await navigator.serviceWorker.register(swUrl, {
    updateViaCache: "none",
  });

  try {
    await registration.update();
  } catch (error) {
    console.warn("Service Worker update check failed:", error);
  }

  await waitForActiveServiceWorker(registration);

  return registration;
}
